import React, { memo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useWorkspaceAssetsDispatch } from '@desygner/ui-editor-menus';

const typeMap = {
  Image: 'image',
  Icon: 'icon',
  Logo: 'logo',
  Text: 'text',
  Video: 'video'
};

function AssetManager ({ workspaceAssetType }) {
  const dispatch = useWorkspaceAssetsDispatch();

  useEffect(() => {
    const assetsAddedCallback = (assets) => {
      assets = assets.filter(asset => typeMap[asset.details.type] === workspaceAssetType);

      if (!assets) return;

      dispatch({
        type: 'ASSETS_ADDED',
        payload: {
          assets
        }
      });
    };

    INKIVE.EditorFacade.on('assets.added', assetsAddedCallback);

    return () => {
      INKIVE.EditorFacade.off('assets.added', assetsAddedCallback);
    };
  }, []);

  return <div />;
}

AssetManager.propTypes = {
  workspaceAssetType: PropTypes.string.isRequired
};

export default memo(AssetManager);
